const area = {
    namespaced: true,
    state: {
        // 章节测试信息
        testExamInfo: {},
        // 考试剩余时间
        testExamTime:{},
        // 题型列表（根据课程id）
        questionTypeList:[],
        // 当前题目id
        currentQuestionId:'',
        // 是否是闯关提交，闯关提交需要弹框提示
        isChallengeSubmit:false,
        // 闯关关卡
        challengeSort:0,
        // 用于判断是否调用返回（答题完）
        examIsBack: false,
    },
    getters: {

    },
    mutations: {
        /** 章节测试信息 */
        setTestExamInfo(state, value) {
            state.testExamInfo = value;
        },
        /** 考试剩余时间 */
        setTestExamTime(state,value){
            state.testExamTime = value;
        },
        // 题型列表（根据课程id）
        setQuestionTypeList(state,value){
            state.questionTypeList = value;
        },
        // 当前题目id
        setCurrentQuestionId(state,value){
            state.currentQuestionId = value;
        },
        // 是否是闯关提交，闯关提交需要弹框提示
        setIsChallengeSubmit(state,value){
            state.isChallengeSubmit = value;
        },
        // 闯关关卡
        setChallengeSort(state,value){
            state.challengeSort = value;
        },
        // 用于判断是否调用返回（答题完）
        setExamIsBack(state,value){
            state.examIsBack = value;
        }
    },
    actions: {
    }
}

export default area